import classNames from "classnames";
import moment from "moment-mini";
import React from "react";
import { compose } from "redux";

import withTranslations from "../../../../../../hocs/withTranslations";
import ChevronLeft from "../../Homepage/assets/icons/chevron-left.svg";
import { notificationPropTypes } from "./Notification";
import NotificationTag from "./NotificationTag";
import NotificationSubMessage from "./NotificationSubMessage";
import SquaberLink from "../../../../common/SquaberLink";

const NotificationMobile = ({
  icon,
  tags,
  stock,
  date,
  read,
  title,
  subtitle,
  beforeDescription,
  subMessage,
  description,
  onClick,
  href,
  leftAccent
}) => {
  const content = (
    <>
      {leftAccent ? (
        <span
          className={"absolute top-0 left-0 bottom-0 w-1 bg-yellow"}
          aria-hidden={"true"}
        />
      ) : null}
      <div className={"flex gap-3"}>
        {icon ? (
          <div className={"flex flex-col align-center shrink-0"}>
            <img
              src={icon.src}
              alt={icon?.alt ?? ""}
              width={32}
              height={32}
              className={"shrink-0"}
            />
            {icon.tag ? (
              <NotificationTag
                key={icon.tag.text}
                type={icon.tag.type}
                text={icon.tag.text}
                prefix={icon.tag.prefix}
              />
            ) : null}
          </div>
        ) : null}
        <div className={"flex gap-1 flex-col w-full"}>
          <div className={"flex gap-3 align-center"}>
            {Array.isArray(tags) && tags.length > 0 ? (
              <div className={"flex gap-1.5"}>
                {tags.map(tag => {
                  return <NotificationTag key={tag.text} {...tag} />;
                })}
              </div>
            ) : null}
            {subtitle ? (
              <strong
                className={classNames(
                  "text-sm text-black truncate normal-case",
                  {
                    "font-semibold": !read,
                    "font-medium": read
                  }
                )}
              >
                {subtitle}
              </strong>
            ) : null}
            {stock ? (
              <div className={"flex justify-between gap-2 w-full"}>
                {stock?.ticker ? (
                  <span
                    className={
                      "text-black text-lg font-bold align-top text-left"
                    }
                  >
                    {stock.ticker}
                  </span>
                ) : null}
                {stock?.market ? (
                  <span
                    className={
                      "text-black opacity-50 text-xs.1 font-medium ml-auto"
                    }
                  >
                    {stock.market}
                  </span>
                ) : null}
              </div>
            ) : null}
          </div>
          {title ? (
            <strong
              className={classNames("text-sm text-left normal-case", {
                "font-semibold": !read,
                "font-medium": read
              })}
            >
              {title}
            </strong>
          ) : null}
          {beforeDescription}
          {subMessage ? <NotificationSubMessage html={subMessage} /> : null}
          {description ? (
            <p className={"text-xs font-medium text-left m-0 normal-case"}>
              {description}
            </p>
          ) : null}
        </div>
      </div>
      <div className={"flex gap-2 justify-between"}>
        <div className={"flex gap-2 shrink-0"}>
          {read ? null : (
            <span className={"w-2 h-2 bg-red-1 rounded-full shrink-0"} />
          )}
          {date ? (
            <span className={"text-xs.1 font-medium text-black opacity-50"}>
              {moment(date).format("DD.MM.YYYY, HH:mm")}
            </span>
          ) : null}
        </div>
        <img
          src={ChevronLeft}
          width={12}
          height={12}
          alt={""}
          className={"shrink-0"}
        />
      </div>
    </>
  );

  const common = {
    className: classNames(
      "text-black b-none flex flex-col gap-2 px-4 py-2 w-full hover:bg-gray-3 hover:text-black",
      {
        "bg-gray-3.80": !read,
        "bg-white": read,
        "relative overflow-hidden": leftAccent
      }
    ),
    onClick: onClick
  };

  if (href) {
    return (
      <SquaberLink to={href} {...common}>
        {content}
      </SquaberLink>
    );
  }

  return <button {...common}>{content}</button>;
};

NotificationMobile.propTypes = notificationPropTypes;

export default compose(withTranslations)(NotificationMobile);
